window.DASH_TWINE_QUICK_QUESTIONS = [
  {
    label: "Everyday Perfume",
    question: "Which perfume is best for everyday use?"
  },
  {
    label: "Rich & Woody",
    question: "Which men's perfume is rich and woody?"
  },
  {
    label: "Unisex Perfumes",
    question: "Which unisex perfume is suitable for all age groups?"
  },
  {
    label: "Summer Perfumes",
    question: "What perfume is good for summer?"
  },
  {
    label: "Date Night",
    question: "Which perfume is best for a date night?"
  },
  {
    label: "Long Lasting",
    question: "Which perfume has the best longevity?"
  }
];


/* =========================================================
   DASH & TWINE CHATBOT DATA
   ========================================================= */

const DASH_TWINE_CHATBOT = {

  /* =======================================================
     CONTACT
     ======================================================= */

  contact: {
    whatsapp: "971588035699",
    phone: "+971588035699",
    email: "dashandtwine2025@gmail.com",
  },


  /* =======================================================
     FAQS
     ======================================================= */

  faqs: [

    /* -------------------------------------------------------
       GENERAL
    ------------------------------------------------------- */

    {
      question: "What perfume brands do you sell?",
      keywords: [
        "perfume brands",
        "brands do you sell",
        "which perfume brands",
        "what brands",
        "brands available"
      ],
      answer:
        "Dash & Twine offers a curated collection of authentic fragrances from leading Middle Eastern perfume houses, including Lattafa, Maison Alhambra, Lattafa Pride and Niche Emirati. Our collection includes perfumes for men, women and unisex preferences."
    },

    {
      question: "Are your perfumes authentic and genuine?",
      keywords: [
        "authentic perfume",
        "genuine perfume",
        "original perfume",
        "authentic fragrances",
        "are perfumes authentic",
        "are perfumes genuine",
        "fake perfume"
      ],
      answer:
        "Yes. All perfumes available at Dash & Twine are 100% authentic and sourced from authorized distributors and trusted suppliers."
    },

    {
      question: "Do all perfumes come sealed?",
      keywords: [
        "perfumes sealed",
        "come sealed",
        "sealed perfume",
        "original packaging",
        "sealed packaging"
      ],
      answer:
        "Yes. Our perfumes are supplied in their original branded packaging and are sealed by the manufacturer."
    },

    {
      question: "Are these perfumes suitable for gifting?",
      keywords: [
        "perfume gifting",
        "perfumes for gifting",
        "suitable for gifting",
        "gift perfume",
        "perfume gift"
      ],
      answer:
        "Yes. Many of our perfumes feature premium packaging, making them excellent gifts for birthdays, anniversaries, Eid, weddings and other special occasions."
    },


    /* -------------------------------------------------------
       EDP / EDT
    ------------------------------------------------------- */

    {
      question: "What does EDP mean?",
      keywords: [
        "what is edp",
        "what does edp mean",
        "edp meaning",
        "meaning of edp",
        "eau de parfum"
      ],
      answer:
        "EDP stands for Eau de Parfum. It generally has a higher fragrance-oil concentration than Eau de Toilette (EDT), which usually means richer scent and better longevity."
    },

    {
      question: "Do you sell Eau de Parfum?",
      keywords: [
        "sell edp",
        "do you sell edp",
        "eau de parfum",
        "edp perfumes",
        "perfumes edp"
      ],
      answer:
        "Yes. Most perfumes in our collection are Eau de Parfum (EDP), which generally provides better longevity and projection than lighter Eau de Toilette fragrances."
    },

    {
      question: "What is the difference between EDP and EDT?",
      keywords: [
        "edp vs edt",
        "edp edt difference",
        "difference between edp and edt",
        "difference edp edt"
      ],
      answer:
        "The main difference is fragrance-oil concentration. Parfum/Extrait generally has the highest concentration, EDP is lighter but still long-lasting, and EDT is generally lighter and often suited to casual or warm-weather use."
    },


    /* -------------------------------------------------------
       LONGEVITY
    ------------------------------------------------------- */

    {
      question: "How long do these perfumes last?",
      keywords: [
        "how long perfume last",
        "how long do perfumes last",
        "perfume longevity",
        "perfume lasts",
        "fragrance longevity"
      ],
      answer:
        "Longevity varies depending on the fragrance, skin type, weather and application. Most EDP perfumes in our collection typically last around 6–10 hours, while some richer oud and amber fragrances can last even longer."
    },

    {
      question: "Are Lattafa perfumes long-lasting?",
      keywords: [
        "lattafa long lasting",
        "lattafa longevity",
        "lattafa lasts long",
        "are lattafa perfumes long lasting"
      ],
      answer:
        "Yes. Lattafa fragrances are generally known for strong longevity and projection. Performance can vary depending on the specific fragrance, skin chemistry and weather."
    },

    {
      question: "Which perfumes have the best longevity?",
      keywords: [
        "best longevity",
        "longest lasting perfume",
        "long lasting perfumes",
        "best lasting perfume",
        "strong longevity"
      ],
      answer:
        "Some fragrances known for strong longevity include Lattafa Khamrah, Khamrah Qahwa, Bade'e Al Oud For Glory, Bade'e Al Oud Honor and Glory, Ameer Al Oudh Intense Oud, Asad, Maison Alhambra Hercules and Infini Oud."
    },

    {
      question: "Which perfumes have strong projection?",
      keywords: [
        "strong projection",
        "best projection",
        "strong projecting perfume",
        "projection perfumes",
        "strong scent trail"
      ],
      answer:
        "Fragrances known for noticeable projection include Lattafa Asad, Khamrah, Khamrah Qahwa, Bade'e Al Oud For Glory, Maison Alhambra Hercules and Smoky Touch."
    },


    /* -------------------------------------------------------
       WEATHER
    ------------------------------------------------------- */

    {
      question: "Are these perfumes suitable for UAE weather?",
      keywords: [
        "uae weather perfume",
        "dubai weather perfume",
        "hot weather perfume",
        "warm climate perfume",
        "perfume for uae"
      ],
      answer:
        "Yes. Many of our fragrances are created by Middle Eastern perfume houses and perform well in warm climates. Fresh fragrances are great for daytime, while oud, amber, vanilla and spicy fragrances are excellent for evenings."
    },


    /* -------------------------------------------------------
       SIZE
    ------------------------------------------------------- */

    {
      question: "What sizes do the perfumes come in?",
      keywords: [
        "perfume sizes",
        "bottle sizes",
        "what sizes",
        "how many ml",
        "100ml perfume",
        "80ml perfume"
      ],
      answer:
        "Most fragrances are offered as 100 mL bottles, while some are also available in 80 mL sizes."
    },


    /* -------------------------------------------------------
       UNISEX
    ------------------------------------------------------- */

    {
      question: "Are these perfumes unisex or gender-specific?",
      keywords: [
        "unisex perfume",
        "gender specific perfume",
        "gender specific",
        "men women perfume",
        "perfumes for men women"
      ],
      answer:
        "We carry fragrances marketed for men, women and many unisex blends. Ultimately, fragrance is a matter of personal preference."
    },

    {
      question: "Can men wear unisex perfumes?",
      keywords: [
        "men wear unisex",
        "can men wear unisex",
        "unisex for men",
        "men unisex perfume"
      ],
      answer:
        "Absolutely! Unisex fragrances are designed to be enjoyed by anyone. The best choice depends on your personal taste and preferred scent profile."
    },

    {
      question: "Can women wear men's perfumes?",
      keywords: [
        "women wear mens perfume",
        "women wear men's perfume",
        "mens perfume for women",
        "women men's fragrance"
      ],
      answer:
        "Yes. Many women enjoy fragrances marketed for men, especially woody, fresh, spicy and aromatic profiles. Fragrance has no strict rules — wear what you love."
    },

    {
      question: "Which Lattafa or Maison Alhambra perfumes are unisex?",
      keywords: [
        "lattafa unisex",
        "alhambra unisex",
        "which perfumes are unisex",
        "unisex lattafa",
        "unisex alhambra"
      ],
      answer:
        "Many Lattafa and Maison Alhambra fragrances are unisex. Examples include Lattafa Niche Emirati Mughal Fort, Khanjar, Khamrah, Ajwad, Atlas and several Jean Lowe fragrances."
    },

    {
      question: "Which unisex perfume is suitable for all age groups?",
      keywords: [
        "unisex all age groups",
        "unisex perfume all ages",
        "unisex suitable for all age groups",
        "unisex for all ages",
        "unisex all age",
        "all age unisex perfume"
      ],
      answer:
        "Versatile unisex choices suitable for a wide range of preferences include Ajwad, Eternal Touch, Atlas, Pacific Blue and Jean Lowe Azure."
    },


    /* -------------------------------------------------------
       SAMPLES
    ------------------------------------------------------- */

    {
      question: "Do you offer travel-size bottles or sample vials?",
      keywords: [
        "travel size",
        "sample vial",
        "sample vials",
        "perfume samples",
        "travel size perfume",
        "do you sell samples"
      ],
      answer:
        "We do not currently sell sample vials. Most of our items are available in full-size bottles."
    },


    /* -------------------------------------------------------
       APPLICATION
    ------------------------------------------------------- */

    {
      question: "How can I make my perfume last longer?",
      keywords: [
        "make perfume last longer",
        "perfume last longer",
        "increase perfume longevity",
        "longer lasting perfume"
      ],
      answer:
        "To make your perfume last longer:\n\n1. Apply it to moisturized skin and pulse points.\n2. Avoid rubbing your wrists together after spraying.\n3. Keep your skin hydrated.\n4. Reapply lightly during the day if needed."
    },

    {
      question: "How should I apply perfume for best results?",
      keywords: [
        "how to apply perfume",
        "best way to apply perfume",
        "apply perfume",
        "where to spray perfume",
        "perfume application"
      ],
      answer:
        "Lightly spray perfume on pulse points such as your wrists, neck and chest. Hold the bottle around 5–10 cm from your skin, spray once or twice and let it air-dry. Avoid rubbing your wrists together."
    },

    {
      question: "Can I wear perfume on my clothes?",
      keywords: [
        "perfume on clothes",
        "spray perfume clothes",
        "wear perfume clothes",
        "perfume clothing"
      ],
      answer:
        "Yes, but use caution. Avoid delicate fabrics such as silk because perfume may stain them. Spray lightly from a distance. Fragrance can also smell differently on fabric compared with skin."
    },

    {
      question: "How many sprays of perfume are recommended?",
      keywords: [
        "how many sprays",
        "number of sprays",
        "perfume sprays",
        "how much perfume"
      ],
      answer:
        "Typically, 1–3 sprays are enough for most people. Since EDPs can be quite concentrated, start lightly and add another spray later if needed."
    },

    {
      question: "Can I layer different perfumes together?",
      keywords: [
        "layer perfumes",
        "layer perfume",
        "layer two perfumes",
        "can i layer perfume",
        "perfume layering"
      ],
      answer:
        "Yes! Layering can create a unique fragrance. Try combining compatible scent profiles, such as woody with citrus or vanilla with oud. Start with a small amount and gradually build the combination."
    },

    {
      question: "Should I shake the perfume bottle?",
      keywords: [
        "shake perfume",
        "shake perfume bottle",
        "should i shake perfume"
      ],
      answer:
        "No. Shaking your perfume bottle is unnecessary. Simply spray or dab it as directed on the packaging."
    },

    {
      question: "How should I store my perfume?",
      keywords: [
        "store perfume",
        "perfume storage",
        "keep perfume fresh",
        "where keep perfume"
      ],
      answer:
        "Store perfume in a cool, dark place away from direct sunlight and heat. A drawer or closet at room temperature is ideal. Keep the cap tightly closed after use."
    },

    {
      question: "Does perfume expire?",
      keywords: [
        "perfume expire",
        "does perfume expire",
        "perfume go bad",
        "perfume expiration"
      ],
      answer:
        "Yes, perfume can gradually degrade over time as fragrance oils oxidize. Changes such as unusual smell or colour can indicate deterioration. Proper storage away from heat and sunlight can help preserve the fragrance."
    },


    /* -------------------------------------------------------
       OUD
    ------------------------------------------------------- */

    {
      question: "What is oud?",
      keywords: [
        "what is oud",
        "oud meaning",
        "what is oudh",
        "oud perfume"
      ],
      answer:
        "Oud, also spelled oudh, is a rich aromatic material associated with agarwood. It is highly valued in Middle Eastern perfumery and is known for its deep, warm, woody and sometimes smoky character."
    },

    {
      question: "I like oud perfumes. What should I buy?",
      keywords: [
        "like oud",
        "oud recommendation",
        "recommend oud",
        "best oud perfume",
        "oud fragrances"
      ],
      answer:
        "If you enjoy oud, consider:\n\n• Lattafa Bade'e Al Oud For Glory\n• Lattafa Bade'e Al Oud For Honor and Glory\n• Lattafa Oud Mood\n• Lattafa Ameer Al Oudh Intense Oud\n• Maison Alhambra Infini Oud\n• Maison Alhambra The Memory Of Oud\n• Niche Emirati Khanjar"
    },


    /* -------------------------------------------------------
       SWEET
    ------------------------------------------------------- */

    {
      question: "I like sweet perfumes. What should I buy?",
      keywords: [
        "sweet perfume",
        "sweet fragrances",
        "i like sweet",
        "recommend sweet perfume"
      ],
      answer:
        "If you like sweet fragrances, consider Lattafa Khamrah, Eclaire, Yara, Pride Nebras, Maison Alhambra Sensual Vanilla or Montaigne Vanille."
    },

    {
      question: "I like sweet perfumes but not heavy scents.",
      keywords: [
        "sweet but not heavy",
        "sweet not heavy",
        "sweet but light",
        "not too heavy sweet"
      ],
      answer:
        "If you like sweet fragrances but don't want something too heavy, consider Lattafa Yara, Eclaire, Maison Alhambra Coral Blush, Love Spark or Pink Velvet."
    },


    /* -------------------------------------------------------
       FRESH
    ------------------------------------------------------- */

    {
      question: "I like fresh perfumes. Recommend some.",
      keywords: [
        "fresh perfume",
        "fresh fragrances",
        "i like fresh",
        "recommend fresh perfume"
      ],
      answer:
        "For fresh fragrances, consider Lattafa Maahir Legacy, Maison Alhambra Glacier Pour Homme, Pacific Blue, Jorge Di Profumo Aqua or Alpine Homme Sport."
    },


    /* -------------------------------------------------------
       VANILLA
    ------------------------------------------------------- */

    {
      question: "I like vanilla perfumes. Suggest some.",
      keywords: [
        "vanilla perfume",
        "vanilla fragrances",
        "i like vanilla",
        "recommend vanilla perfume"
      ],
      answer:
        "For vanilla lovers, consider Lattafa Khamrah, Eclaire, Pride Nebras, Maison Alhambra Montaigne Vanille or Sensual Vanilla."
    },


    /* -------------------------------------------------------
       WOODY
    ------------------------------------------------------- */

    {
      question: "Which men's perfume is rich and woody?",
      keywords: [
        "mens rich woody",
        "mens perfume rich woody",
        "rich woody perfume men",
        "men woody perfume",
        "mens woody fragrance",
        "rich and woody",
        "woody perfume men"
      ],
      answer:
        "For a rich woody profile, consider Lattafa Asad Bourbon, Musamam, Maison Alhambra Afro Leather, Herculean Leather or Opulence Leather."
    },

    {
      question: "I like woody perfumes. What should I buy?",
      keywords: [
        "woody perfume",
        "woody fragrances",
        "i like woody",
        "recommend woody perfume"
      ],
      answer:
        "For woody fragrances, consider Lattafa Asad, Musamam, Maison Alhambra Hercules, Opulence Leather or Afro Leather."
    },


    /* -------------------------------------------------------
       FLORAL
    ------------------------------------------------------- */

    {
      question: "I like floral perfumes. Suggest some.",
      keywords: [
        "floral perfume",
        "floral fragrances",
        "i like floral",
        "recommend floral perfume"
      ],
      answer:
        "For floral fragrances, consider Lattafa Fakhar Women, Yara, Maison Alhambra Delilah Blanc, Leonie or Pink Velvet."
    },


    /* -------------------------------------------------------
       MEN
    ------------------------------------------------------- */

    {
      question: "Which men's perfume smells masculine?",
      keywords: [
        "mens masculine perfume",
        "mens perfume masculine",
        "masculine fragrance",
        "masculine perfume",
        "mens perfume smells masculine",
        "best masculine perfume"
      ],
      answer:
        "Popular masculine choices include Lattafa Asad, Fakhar Men, Toro Pour Homme, Salvo, Kingsman and Victorioso Heroic."
    },

    {
      question: "Which men's perfumes are popular?",
      keywords: [
        "popular mens perfume",
        "popular lattafa men",
        "best mens perfume",
        "mens perfume popular",
        "popular perfumes for men"
      ],
      answer:
        "Popular choices for men include Lattafa Asad, Fakhar Men and Maahir Legacy. Many men also enjoy bold oud, spicy, woody and fresh fragrances."
    },

    {
      question: "Which men's perfume is fresh and sporty?",
      keywords: [
        "fresh mens perfume",
        "sporty mens perfume",
        "fresh perfume men",
        "mens fresh fragrance"
      ],
      answer:
        "Fresh and sporty choices include Maison Alhambra Glacier Pour Homme, Alpine Homme Sport, Jorge Di Profumo Aqua, Pacific Blue and Glacier Ultra."
    },

    {
      question: "Which men's perfume is rich and woody?",
      keywords: [
        "rich woody men",
        "woody men perfume",
        "rich woody mens",
        "rich woody fragrance men"
      ],
      answer:
        "Excellent rich woody choices include Lattafa Asad Bourbon, Musamam, Maison Alhambra Afro Leather, Herculean Leather and Opulence Leather."
    },


    /* -------------------------------------------------------
       WOMEN
    ------------------------------------------------------- */

    {
      question: "Which Lattafa perfumes are popular among women?",
      keywords: [
        "lattafa women popular",
        "popular lattafa women",
        "best lattafa women",
        "lattafa perfumes women"
      ],
      answer:
        "Popular Lattafa choices among women include Yara, Dynasty Woman and Fakhar Women."
    },

    {
      question: "Which women's perfume is suitable for everyday use?",
      keywords: [
        "women everyday perfume",
        "women daily perfume",
        "everyday perfume women",
        "womens everyday fragrance"
      ],
      answer:
        "Great everyday choices for women include Yara, Fakhar Women, Delilah Blanc, Pink Velvet and Coral Blush."
    },


    /* -------------------------------------------------------
       DAY / OFFICE
    ------------------------------------------------------- */

    {
      question: "Which perfumes are best for daytime or office wear?",
      keywords: [
        "daytime perfume",
        "day time perfume",
        "office perfume",
        "best daytime",
        "day wear perfume"
      ],
      answer:
        "For daytime or office wear, fresher and lighter fragrances are generally versatile. Good options include Lattafa Maahir Legacy, Fakhar Men, Fakhar Women, Maison Alhambra Glacier Pour Homme, Jean Lowe Azure and Pacific Blue."
    },

    {
      question: "Which perfumes are best for office use?",
      keywords: [
        "office use",
        "best perfume office",
        "perfume for office",
        "office fragrance"
      ],
      answer:
        "For office wear, lighter and cleaner fragrances are usually preferred. Consider Lattafa Maahir Legacy, Fakhar Men, Maison Alhambra Jorge Di Profumo, Jean Lowe Azure or Pacific Blue."
    },


    /* -------------------------------------------------------
       EVENING
    ------------------------------------------------------- */

    {
      question: "Which perfumes are best for parties or evening wear?",
      keywords: [
        "party perfume",
        "perfume parties",
        "evening perfume",
        "evening wear",
        "night perfume"
      ],
      answer:
        "For parties and evening wear, consider Lattafa Khamrah, Khamrah Qahwa, Ameer Al Oudh Intense Oud, Bade'e Al Oud For Glory, Maison Alhambra Hercules or Smoky Touch."
    },


    /* -------------------------------------------------------
       SUMMER / WINTER
    ------------------------------------------------------- */

    {
      question: "Which perfumes are best for summer?",
      keywords: [
        "summer perfume",
        "best perfume summer",
        "perfume for summer",
        "summer fragrance"
      ],
      answer:
        "Fresh fragrances are often ideal for summer. Recommended choices include Maison Alhambra Glacier Pour Homme, Jorge Di Profumo Aqua, Pacific Blue, Alpine Homme Sport, Jean Lowe Fraiche and Lattafa Maahir Legacy."
    },

    {
      question: "Which perfumes are best for winter?",
      keywords: [
        "winter perfume",
        "best perfume winter",
        "perfume for winter",
        "winter fragrance"
      ],
      answer:
        "For winter, richer and warmer fragrances work beautifully. Consider Lattafa Khamrah, Ameer Al Oudh Intense Oud, Oud Mood, Maison Alhambra Smoked Oud & Vanilla, Sensual Vanilla or Infini Oud."
    },


    /* -------------------------------------------------------
       SPECIFIC PERFUMES
    ------------------------------------------------------- */

    {
      question: "What does Lattafa Yara smell like?",
      keywords: [
        "lattafa yara",
        "yara smell",
        "yara scent",
        "what is yara scent"
      ],
      answer:
        "Lattafa Yara has a fruity, tropical vanilla character and is a very popular feminine fragrance."
    },

    {
      question: "What does Lattafa Khamrah smell like?",
      keywords: [
        "lattafa khamrah",
        "khamrah smell",
        "khamrah scent",
        "what does khamrah smell like"
      ],
      answer:
        "Lattafa Khamrah is rich and sweet, with warm bergamot, cinnamon and nutmeg alongside sweet gourmand and woody elements. The overall result is cozy, luxurious and warm."
    },

    {
      question: "How is Khamrah Qahwa different?",
      keywords: [
        "khamrah qahwa",
        "khamrah vs qahwa",
        "difference khamrah qahwa",
        "qahwa different"
      ],
      answer:
        "Khamrah Qahwa is a coffee-infused twist on the original Khamrah. It retains warm spicy and sweet elements but adds a prominent coffee, musk, vanilla and tonka-bean character, making it deeper and warmer."
    },

    {
      question: "What's the difference between Asad and Asad Bourbon?",
      keywords: [
        "asad vs asad bourbon",
        "difference asad bourbon",
        "asad bourbon",
        "asad compared bourbon"
      ],
      answer:
        "Lattafa Asad is a warm spicy woody fragrance, while Asad Bourbon adds a smoother bourbon-inspired warmth with richer sweetness and depth."
    },

    {
      question: "Which Yara perfume should I choose?",
      keywords: [
        "which yara",
        "which yara perfume",
        "choose yara",
        "best yara"
      ],
      answer:
        "If you're looking for a soft, sweet and creamy everyday fragrance, Lattafa Yara is an excellent choice and one of the brand's popular women's fragrances."
    },


    /* -------------------------------------------------------
       GIFTS
    ------------------------------------------------------- */

    {
      question: "I'm shopping for my husband. What do you recommend?",
      keywords: [
        "perfume for husband",
        "buying for husband",
        "gift for husband",
        "husband perfume"
      ],
      answer:
        "Popular gifts for men include Lattafa Asad, Fakhar Men, The Kingdom Men, Maison Alhambra Salvo and Glacier Pour Homme."
    },

    {
      question: "I'm shopping for my wife. What do you recommend?",
      keywords: [
        "perfume for wife",
        "buying for wife",
        "gift for wife",
        "wife perfume"
      ],
      answer:
        "For your wife, consider Lattafa Yara, Eclaire, Her Confession, Maison Alhambra Delilah Blanc or Pink Velvet."
    },

    {
      question: "I need a unisex perfume gift.",
      keywords: [
        "unisex gift",
        "unisex perfume gift",
        "gift for anyone perfume"
      ],
      answer:
        "Excellent unisex gift options include Lattafa Khamrah, Ajwad, Atlas, Maison Alhambra Eternal Touch and Flaming Elixir."
    },


    /* -------------------------------------------------------
       UNIQUE / LUXURY
    ------------------------------------------------------- */

    {
      question: "I want something unique that not everyone wears.",
      keywords: [
        "unique perfume",
        "not everyone wears",
        "something unique",
        "distinctive perfume"
      ],
      answer:
        "For something more distinctive, consider Artisan Ethnique, Vintage Radio, Musamam, Mughal Fort, Khanjar, Jean Lowe Matiere or Afro Leather."
    },

    {
      question: "Which perfume smells rich and expensive?",
      keywords: [
        "rich expensive perfume",
        "smells expensive",
        "expensive smelling perfume",
        "premium scent",
        "luxury perfume"
      ],
      answer:
        "For a premium scent profile, consider Lattafa Pride Vintage Radio, Pride Queen of Arabia, Niche Emirati Khanjar, Niche Emirati Mughal Fort, Maison Alhambra Hercules, Lattafa Musamam or Afeef."
    },

    {
      question: "Which perfumes are mature and sophisticated?",
      keywords: [
        "mature sophisticated",
        "sophisticated perfume",
        "mature perfume",
        "elegant mature"
      ],
      answer:
        "For a mature and sophisticated profile, consider Lattafa Musamam, Niche Emirati Mughal Fort, Maison Alhambra Afro Leather, The Memory Of Oud or Lattafa Ameer Al Oudh Intense Oud."
    },


    /* -------------------------------------------------------
       GENERAL RECOMMENDATION
    ------------------------------------------------------- */

    {
      question: "Can you recommend a perfume for me?",
      keywords: [
        "recommend perfume",
        "recommend a perfume",
        "which perfume should i buy",
        "help me choose perfume",
        "suggest perfume",
        "what perfume should i buy"
      ],
      answer:
        "Of course! Tell me:\n\n• Are you shopping for Men, Women or Unisex?\n• Do you like fresh, sweet, oud, woody, spicy, vanilla, fruity or floral scents?\n• Is it for daily wear, office, date night, weddings or a special occasion?\n\nI'll recommend suitable options from our collection."
    },


    /* -------------------------------------------------------
       PROMOTIONS
    ------------------------------------------------------- */

    {
      question: "Are there any discounts or promotions?",
      keywords: [
        "discount",
        "discounts",
        "promotion",
        "promotions",
        "offers",
        "perfume sale",
        "sale"
      ],
      answer:
        "Promotions can vary. We occasionally run sales and offers. Please check the Dash & Twine website and Instagram for current promotions."
    },


    /* -------------------------------------------------------
       STORE
    ------------------------------------------------------- */

    {
      question: "Can I try the perfume in-store?",
      keywords: [
        "try perfume",
        "test perfume",
        "smell perfume",
        "try in store",
        "test in store",
        "smell in store",
        "visit store"
      ],
      answer:
        "Yes! Feel free to visit our Dubai store at Manazel Al Barsha, where you can test and experience our fragrances in person before purchasing."
    },


    /* -------------------------------------------------------
       RETURN
    ------------------------------------------------------- */

    {
      question: "Can I return items?",
      keywords: [
        "return",
        "return item",
        "return product",
        "return policy",
        "can i return"
      ],
      answer:
        "Thank you for contacting Dash & Twine. For information about our return policy, please visit our Refund & Return Policy page. For specific assistance, please contact our in-store team via WhatsApp or phone.",
      link: {
        text: "View Return & Refund Policy",
        url: "/policies/refund-policy"
      }
    },


    /* -------------------------------------------------------
       PAYMENT
    ------------------------------------------------------- */

    {
      question: "What cards are accepted?",
      keywords: [
        "visa",
        "mastercard",
        "master card",
        "amex",
        "american express",
        "cards accepted",
        "payment cards"
      ],
      answer:
        "We accept Visa, Mastercard and American Express cards, along with other supported payment methods through our secure payment network."
    },

    {
      question: "Is there a pay-in-installments option?",
      keywords: [
        "installment",
        "installments",
        "pay later",
        "tabby",
        "tamara",
        "payment plan"
      ],
      answer:
        "Yes. Dash & Twine has partnered with Tabby and Tamara to provide convenient installment and pay-later options."
    },

    {
      question: "How do I pay for my purchase?",
      keywords: [
        "how do i pay",
        "how can i pay",
        "payment methods",
        "ways to pay",
        "pay for purchase"
      ],
      answer:
        "You can pay online through our secure payment portal powered by Network International. You can also choose cash or card on delivery."
    },


    /* -------------------------------------------------------
       DELIVERY
    ------------------------------------------------------- */

    {
      question: "What is your shipping policy?",
      keywords: [
        "shipping policy",
        "delivery policy",
        "shipping information",
        "delivery information",
        "shipping",
        "delivery"
      ],
      answer:
        "We offer delivery within the UAE. Within Dubai, most orders can be fulfilled within approximately 2 hours depending on your location and order time. We also offer next-day delivery anywhere within the UAE."
    },

    {
      question: "Do you have express delivery?",
      keywords: [
        "express delivery",
        "express shipping",
        "fast delivery",
        "2 hour delivery",
        "two hour delivery",
        "next day delivery"
      ],
      answer:
        "Yes. Within Dubai, most orders can be fulfilled within approximately 2 hours depending on your location and the time the order is placed. We also offer next-day delivery anywhere within the UAE."
    },

    {
      question: "Is delivery free?",
      keywords: [
        "free delivery",
        "free shipping",
        "is delivery free",
        "is shipping free",
        "free delivery minimum"
      ],
      answer:
        "We offer free delivery on orders above AED 150."
    },


    /* -------------------------------------------------------
       ORDER
    ------------------------------------------------------- */

    {
      question: "How do I track my order?",
      keywords: [
        "track order",
        "track my order",
        "order tracking",
        "where is my order",
        "where's my order",
        "order status",
        "tracking details"
      ],
      answer:
        "You will receive order-status updates via WhatsApp. You can also check your order through your Profile → Orders → the relevant order. Once your order is shipped, tracking details will be sent via WhatsApp."
    },

    {
      question: "I haven't received my order confirmation email.",
      keywords: [
        "confirmation email",
        "order confirmation",
        "email not received",
        "didn't receive confirmation",
        "no confirmation email"
      ],
      answer:
        "We're sorry for the inconvenience. Please check your spam or marketing folder. If you still cannot find your confirmation email, please contact our in-store team via WhatsApp or phone.",
      contact: true
    },

    {
      question: "Can I change my delivery address?",
      keywords: [
        "change address",
        "delivery address",
        "change my address",
        "update address",
        "wrong address"
      ],
      answer:
        "You can contact our support team to change your delivery address before your order is shipped. Once the parcel has been handed over to the delivery team, the original address cannot be changed. Our support team can assist with redelivery if required.",
      contact: true
    },

    {
      question: "What if my item is damaged or defective?",
      keywords: [
        "damaged",
        "damaged product",
        "broken product",
        "defective product",
        "item damaged"
      ],
      answer:
        "Our quality-control team checks products carefully before shipping. If your item is damaged during transport, please contact our support team via WhatsApp or email and provide photographic or video proof. We'll assist you with a replacement.",
      contact: true
    },


    /* -------------------------------------------------------
       REFUND
    ------------------------------------------------------- */

    {
      question: "How long will the refund take?",
      keywords: [
        "refund time",
        "how long refund",
        "refund take",
        "refund credit card",
        "money back",
        "refund bank"
      ],
      answer:
        "Once your refund has been confirmed by our in-store team, it can take 3–5 business days for the bank to process the refund. If you choose store credit, it will be credited instantly."
    },


    /* -------------------------------------------------------
       CANCEL ORDER
       No confirmed company answer supplied.
    ------------------------------------------------------- */

    {
      question: "Can I cancel my order after payment?",
      keywords: [
        "cancel order",
        "cancel my order",
        "cancel after payment",
        "cancel order after payment",
        "order cancellation"
      ],
      answer: null,
      fallback: true
    },


    /* -------------------------------------------------------
       CONTACT
    ------------------------------------------------------- */

    {
      question: "Can I speak with someone from Dash & Twine?",
      keywords: [
        "speak with someone",
        "talk to someone",
        "speak to someone",
        "contact dash and twine",
        "talk with support",
        "speak with support",
        "human support",
        "real person"
      ],
      answer:
        "Absolutely! You can contact a member of our Dash & Twine team directly via WhatsApp, phone or email.",
      contact: true
    }

  ]
};

window.DASH_TWINE_CHATBOT = DASH_TWINE_CHATBOT;

window.DASH_TWINE_FAQS = DASH_TWINE_CHATBOT.faqs;

window.DASH_TWINE_CONTACT = DASH_TWINE_CHATBOT.contact;